// GENERATED by scripts/sync-shared.js from shared/pcafInstrumentCategories.json - do not edit; run `npm run shared:sync`.
export interface PcafInstrumentCategoryDefinition {
	id: number
	pcafCode: string
	name: string
	// One entry per display line; the stored denominatorType joins them.
	denominatorLabel: string[]
	attributionMethod: string
}

export const PCAF_INSTRUMENT_CATEGORIES: PcafInstrumentCategoryDefinition[] = [
	{
		id: 1,
		pcafCode: '5.01',
		name: 'Listed equity and corporate bonds',
		denominatorLabel: ['EVIC (enterprise value including cash)'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 2,
		pcafCode: '5.02',
		name: 'Business loans and unlisted equity',
		denominatorLabel: [
			'Total equity + total debt (alternatively, use total assets instead of equity + debt)',
		],
		attributionMethod: 'single_ratio',
	},
	{
		id: 3,
		pcafCode: '5.03',
		name: 'Project finance',
		denominatorLabel: ['Total equity + total debt of the project'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 4,
		pcafCode: '5.04',
		name: 'Commercial real estate',
		denominatorLabel: ['Property value at origination'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 5,
		pcafCode: '5.05',
		name: 'Mortgages',
		denominatorLabel: ['Property value at origination'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 6,
		pcafCode: '5.06',
		name: 'Motor vehicle loans',
		denominatorLabel: ['Vehicle value at origination'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 7,
		pcafCode: '5.07',
		name: 'Use of proceeds structures',
		denominatorLabel: ['Total equity + total debt of the financed asset'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 8,
		pcafCode: '5.08',
		name: 'Securitization and structured products',
		denominatorLabel: ['Total value of the securitised pool'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 9,
		pcafCode: '5.09',
		name: 'Sovereign debt',
		denominatorLabel: ['PPP-adjusted GDP'],
		attributionMethod: 'single_ratio',
	},
	{
		id: 10,
		pcafCode: '5.10',
		name: 'Sub-sovereign debt',
		denominatorLabel: ['PPP-adjusted GDP'],
		attributionMethod: 'single_ratio',
	},
]
